export const GET_DOCUMENT_TYPE_TURN_REQUEST = "GET_DOCUMENT_TYPE_TURN_REQUEST";
export const GET_DOCUMENT_TYPE_TURN_SUCCESS = "GET_DOCUMENT_TYPE_TURN_SUCCESS";
export const GET_DOCUMENT_TYPE_TURN_FAILURE = "GET_DOCUMENT_TYPE_TURN_FAILURE";

export const GET_DOCUMENT_TYPE_TURN_DOWNLOAD_REQUEST = "GET_DOCUMENT_TYPE_TURN_DOWNLOAD_REQUEST";
export const GET_DOCUMENT_TYPE_TURN_DOWNLOAD_SUCCESS = "GET_DOCUMENT_TYPE_TURN_DOWNLOAD_SUCCESS";
export const GET_DOCUMENT_TYPE_TURN_DOWNLOAD_FAILURE = "GET_DOCUMENT_TYPE_TURN_DOWNLOAD_FAILURE";
